var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-card-title',{staticClass:"mb-1"},[_vm._v(" "+_vm._s(_vm.$t(_vm.i18nTitleVariable))+" ")]),_c('vue-apex-charts',{attrs:{"type":"donut","height":"350","options":this.options,"series":this.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }